import React from "react";
import Checkbox from "../common/Checkbox";
import Input from "../common/Input";
import RadioButton from "../common/RadioButton";
import Select from "../common/Select";

function KYHIFI({ data, handleChange, handleSave }) {
  return (
    <>
      <div className="p-4">
        <div className="text-danger fw-bold d-inline">
          *IMPORTANT* Prior to completing the screener, enter the family’s
          information into the{" "}
        </div>
        <div
          className="btn btn-success ms-2 mb-4"
          onClick={() =>
            window.open("https://hifiwrap-stg.urban.org", "_blank")
          }
        >
          Randomization Site
        </div>
        <div className="row">
          <div className="col">
            <Input
              name="safyPerson"
              label="Person Completing this Screener"
              onChange={handleChange}
              value={data.DynamicFields.results.safyPerson}
            ></Input>
          </div>
          <div className="col">
            <Input
              name="dateOfScreener"
              label="Date of Screener"
              onChange={handleChange}
              value={data.DynamicFields.results.dateOfScreener}
              type="date"
            ></Input>
          </div>
          <div className="col">
            <Input
              name="familyName"
              label="Family Name"
              onChange={handleChange}
              value={data.DynamicFields.results.familyName}
            ></Input>
          </div>
          <div className="col">
            <Input
              name="caseNumber"
              label="Case Number"
              onChange={handleChange}
              value={data.DynamicFields.results.caseNumber}
            ></Input>
          </div>
        </div>
        <Input
          name="familyInfo"
          label="Tell me a little bit about your family and why you were referred for intensive in-home family services?"
          onChange={handleChange}
          value={data.DynamicFields.results.familyInfo}
          rows="4"
        ></Input>
        <div className="h6">
          Based on information provided above, please check if any of the
          following conditions exist:
        </div>
        <div className="row">
          <div className="col">
            <Checkbox
              name="abandonment"
              label="Abandonment"
              onChange={handleChange}
              checked={data.DynamicFields.results.abandonment === "true"}
            ></Checkbox>
            <Checkbox
              name="behaviorProblems"
              label="Behavior Problems"
              onChange={handleChange}
              checked={data.DynamicFields.results.behaviorProblems === "true"}
            ></Checkbox>
            <Checkbox
              name="diagnosedMentalIllness"
              label="Diagnosed Mental Illness"
              onChange={handleChange}
              checked={
                data.DynamicFields.results.diagnosedMentalIllness === "true"
              }
            ></Checkbox>
            <Checkbox
              name="familyConflict"
              label="Family Conflict"
              onChange={handleChange}
              checked={data.DynamicFields.results.familyConflict === "true"}
            ></Checkbox>
            <Checkbox
              name="learningDisability"
              label="Learning Disability"
              onChange={handleChange}
              checked={data.DynamicFields.results.learningDisability === "true"}
            ></Checkbox>
            <Checkbox
              name="neglect"
              label="Neglect"
              onChange={handleChange}
              checked={data.DynamicFields.results.neglect === "true"}
            ></Checkbox>
            <Checkbox
              name="running"
              label="Running/AWOL"
              onChange={handleChange}
              checked={data.DynamicFields.results.running === "true"}
            ></Checkbox>
            <Checkbox
              name="thoughtsOfSuicide"
              label="Thoughts of Suicide"
              onChange={handleChange}
              checked={data.DynamicFields.results.thoughtsOfSuicide === "true"}
            ></Checkbox>
          </div>
          <div className="col">
            <Checkbox
              name="aggression"
              label="Aggression/Assault"
              onChange={handleChange}
              checked={data.DynamicFields.results.aggression === "true"}
            ></Checkbox>
            <Checkbox
              name="delinquency"
              label="Delinquency"
              onChange={handleChange}
              checked={data.DynamicFields.results.delinquency === "true"}
            ></Checkbox>
            <Checkbox
              name="drugUse"
              label="Drug Use"
              onChange={handleChange}
              checked={data.DynamicFields.results.drugUse === "true"}
            ></Checkbox>
            <Checkbox
              name="financial"
              label="Financial"
              onChange={handleChange}
              checked={data.DynamicFields.results.financial === "true"}
            ></Checkbox>
            <Checkbox
              name="legalIssues"
              label="Legal Issues/ Incarceration"
              onChange={handleChange}
              checked={data.DynamicFields.results.legalIssues === "true"}
            ></Checkbox>
            <Checkbox
              name="physicalAbuse"
              label="Physical Abuse"
              onChange={handleChange}
              checked={data.DynamicFields.results.physicalAbuse === "true"}
            ></Checkbox>
            <Checkbox
              name="schoolProblems"
              label="School Problems"
              onChange={handleChange}
              checked={data.DynamicFields.results.schoolProblems === "true"}
            ></Checkbox>
            <Checkbox
              name="other"
              label="Other"
              onChange={handleChange}
              checked={data.DynamicFields.results.other === "true"}
            ></Checkbox>
          </div>
          <div className="col">
            <Checkbox
              name="alcoholUse"
              label="Alcohol Use"
              onChange={handleChange}
              checked={data.DynamicFields.results.alcoholUse === "true"}
            ></Checkbox>
            <Checkbox
              name="developmentalDisability"
              label="Developmental Disability"
              onChange={handleChange}
              checked={
                data.DynamicFields.results.developmentalDisability === "true"
              }
            ></Checkbox>
            <Checkbox
              name="emotionalDisability"
              label="Emotional Disability"
              onChange={handleChange}
              checked={
                data.DynamicFields.results.emotionalDisability === "true"
              }
            ></Checkbox>
            <Checkbox
              name="housing"
              label="Housing"
              onChange={handleChange}
              checked={data.DynamicFields.results.housing === "true"}
            ></Checkbox>
            <Checkbox
              name="medical"
              label="Medical"
              onChange={handleChange}
              checked={data.DynamicFields.results.medical === "true"}
            ></Checkbox>
            <Checkbox
              name="riskySexualBehavior"
              label="Risky Sexual Behavior"
              onChange={handleChange}
              checked={
                data.DynamicFields.results.riskySexualBehavior === "true"
              }
            ></Checkbox>
            <Checkbox
              name="sexualAbuse"
              label="Sexual Abuse"
              onChange={handleChange}
              checked={data.DynamicFields.results.sexualAbuse === "true"}
            ></Checkbox>
          </div>
        </div>
      </div>
      <RadioButton
        name="riskOfRemoval"
        label="Have you been told there’s a possibility that your children are at risk of being removed by the state?"
        options={[
          { name: "Yes", _id: "Yes" },
          { name: "No", _id: "No" },
        ]}
        onChange={handleChange}
        value={data.DynamicFields.results.riskOfRemoval}
      ></RadioButton>
      {data.DynamicFields.results.riskOfRemoval === "Yes" ? (
        <Select
          name="riskScale"
          label="If you could scale the risk of them being placed outside of your home with 1- being it’s not likely to happen and 3-being it’s very likely to happen, where would you scale them?"
          onChange={handleChange}
          value={data.DynamicFields.results.riskScale}
          options={[
            { name: "1- Not at all Likely", _id: "1" },
            { name: "2- Somewhat Likely", _id: "2" },
            { name: "3 – Very Likely", _id: "3" },
            {
              name: "4 – Yes, they are being removed or no longer live in the home",
              _id: "4",
            },
          ]}
        ></Select>
      ) : null}
      <RadioButton
        name="otherServices"
        label="Do you have any other services right now? (Could include Court Designated Workers, therapy, school counselors, etc.)"
        options={[
          { name: "Yes", _id: "Yes" },
          { name: "No", _id: "No" },
        ]}
        onChange={handleChange}
        value={data.DynamicFields.results.otherServices}
      ></RadioButton>
      {data.DynamicFields.results.otherServices === "Yes" ? (
        <Input
          name="describeServices"
          label="Please describe those services"
          onChange={handleChange}
          value={data.DynamicFields.results.describeServices}
          rows="4"
        ></Input>
      ) : (
        <RadioButton
          name="willingToWork"
          label="Are you willing to work with other services?"
          options={[
            { name: "Yes", _id: "Yes" },
            { name: "No", _id: "No" },
          ]}
          onChange={handleChange}
          value={data.DynamicFields.results.willingToWork}
        ></RadioButton>
      )}
      <RadioButton
        name="familiarWithServices"
        label="Are you familiar with what it’s like to be part of intensive in-home family services?"
        options={[
          { name: "Yes", _id: "Yes" },
          { name: "No", _id: "No" },
        ]}
        onChange={handleChange}
        value={data.DynamicFields.results.familiarWithServices}
      ></RadioButton>
      <RadioButton
        name="comfortableWithTeam"
        label="Are you comfortable with the idea of having a team made up of your family, other professionals and supporters that are familiar with your family story and meet regularly to come up with new ideas to help your family?"
        options={[
          { name: "Yes", _id: "Yes" },
          { name: "Maybe", _id: "Maybe" },
          { name: "No", _id: "No" },
        ]}
        onChange={handleChange}
        value={data.DynamicFields.results.comfortableWithTeam}
      ></RadioButton>
      <Input
        name="additionalComments"
        label="Additional Comments"
        onChange={handleChange}
        value={data.DynamicFields.results.additionalComments}
        rows="4"
      ></Input>
      <div className="h6">Screener Decision</div>
      <div className="ms-4">
        <Checkbox
          name="goodFit"
          label="Yes, this family is a good fit and family will be entered into the randomization process"
          onChange={handleChange}
          checked={data.DynamicFields.results.goodFit === "true"}
        ></Checkbox>
        <Checkbox
          name="notGoodFit"
          label="No, this family is not a good fit and family will be marked as ineligible"
          onChange={handleChange}
          checked={data.DynamicFields.results.notGoodFit === "true"}
        ></Checkbox>
        {data.DynamicFields.results.goodFit === "true" ? (
          <>
            <div className="h6">Randomize Results</div>
            <Checkbox
              name="treatment"
              label="Treatment – Let them know their family is a good fit for our intensive in-home family services called “High Fidelity Wrap Around” and get them scheduled for their first session"
              onChange={handleChange}
              checked={data.DynamicFields.results.treatment === "true"}
            ></Checkbox>
            <Checkbox
              name="control"
              label="Control – Let them know their DCBS case manager will be in touch with them on services that fit well with your family"
              onChange={handleChange}
              checked={data.DynamicFields.results.control === "true"}
            ></Checkbox>
          </>
        ) : null}
      </div>
    </>
  );
}

export default KYHIFI;
